import Repository from "./Repository";

const resource = "/Page";
import store from "../store";
export default {
  list() {
    return Repository.get(`${resource}/list`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  create(page) {
    return Repository.post(`${resource}`, page)
      .then((response) => {
        store.commit("setSnack", {
          message: "Изменения сохранены",
          color: "success",
        });
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  get(id) {
    return Repository.get(`${resource}/${id}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  update(supplier) {
    return Repository.patch(`${resource}`, supplier)
      .then((response) => {
        store.commit("setSnack", {
          message: "Изменения сохранены",
          color: "success",
        });
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
